import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";

const WishCtx = createContext(null);
export const useWishlist = () => useContext(WishCtx);

const LS = "bq_wishlist";
const readLS = () => { try { return JSON.parse(localStorage.getItem(LS) || "[]"); } catch { return []; } };

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [items, setItems] = useState(readLS());

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const { data } = await api.get("/wishlist");
        const merged = mergeById([...(data?.items || []), ...readLS()]);
        setItems(merged);
        localStorage.setItem(LS, JSON.stringify(merged));
        await api.put("/wishlist", merged);
      } catch {}
    })();
  }, [user]);

  const persist = async (next) => {
    setItems(next);
    localStorage.setItem(LS, JSON.stringify(next));
    if (user) { try { await api.put("/wishlist", next); } catch {} }
  };

  const has = (id) => items.some(i => i.product_id === id);

  const toggle = (product) => {
    if (has(product.id)) {
      persist(items.filter(i => i.product_id !== product.id));
      toast("Removed from wishlist");
    } else {
      persist([...items, {
        product_id: product.id, title: product.title, subtitle: product.subtitle || "",
        price: product.price, image: product.images?.[0] || product.image,
      }]);
      toast.success("Saved to wishlist", { description: product.title });
    }
  };

  const remove = (id) => persist(items.filter(i => i.product_id !== id));

  return (
    <WishCtx.Provider value={{ items, has, toggle, remove, count: items.length }}>
      {children}
    </WishCtx.Provider>
  );
};

function mergeById(arr) {
  const m = new Map();
  arr.forEach(i => m.set(i.product_id, i));
  return Array.from(m.values());
}
